import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/pediloo/app/trip/[id]/TripDetailsContent.tsx");
